import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { Navigation } from "../Navigation";
import { LoadingPage } from "../LoadingPage";
import { TrendCard } from "../../Components/TrendCard";
import { ItemType } from "../../Components/interface";
import Carousel from "react-spring-3d-carousel";
import { config } from "react-spring";
import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "react-query";
import { apiUrl } from "../../Components/config";
import { useHttp, useHorizontalScroll } from "../../Hooks";

export const Trend = () => {
  const { name } = useParams();
  const [hideLoading, setHideLoading] = useState(false);
  const [goToSlide, setGoToSlide] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [items, setItems] = useState<any>([]);
  const navigate = useNavigate();

  const client = useHttp();
  const {
    data: apiData,
    isLoading,
    isError,
    status,
  } = useQuery<ItemType[], string>(["toplist"], () => {
    return client("toplist", { url: apiUrl });
  });

  const offsetFn = (index: number, currentIndex: number) => {
    const offset = index - currentIndex;

    // Calculate scale and opacity based on offset
    const scale = offset === 0 ? 1 : 0.75;
    const opacity = 1 - Math.abs(offset) * 0.25;

    return {
      transform: `scale(${scale})`,
      opacity,
    };
  };

  useEffect(() => {
    const list = apiData?.map((item, index) => {
      return {
        key: index,
        content: <TrendCard item={item} />,
        onClick: () => setGoToSlide(index),
      };
    });

    if (isMobile) {
      if (apiData) {
        setItems(apiData);
      }
    } else {
      if (list) {
        setItems(list);
      }
    }
  }, [isLoading]);

  return (
    <>
      {(isLoading || items.length < 1) && (
        <LoadingPage text="Loading Today's Most Popular Picks" />
      )}
      <div className={"popular"}>
        <Navigation name="popular" />
        {isMobile ? (
          <TrendCard item={items[0]} />
        ) : (
          <div
            style={{
              width: isMobile ? "100%" : "500px",
              height: "500px",
              marginTop: isMobile ? "-230px" : "-150px",
            }}
          >
            <Carousel
              slides={items}
              goToSlide={goToSlide}
              offsetRadius={2}
              showNavigation={false}
              animationConfig={config.gentle}
              offsetFn={(index) => offsetFn(index, currentIndex)}
            />
          </div>
        )}
      </div>
    </>
  );
};
